<template>
    <div class="wcyc-tree-select" v-clickoutside="handleClose">
        <el-input v-model='finalModel' readonly :placeholder="placeholder" @click.native="toggleDrop" suffix-icon="el-icon-arrow-down"></el-input>
        <el-tree v-show="showDropdown" :props="props" :data="data" :expand-on-click-node="false" @node-click="deptTreeNodeHandleClick" class="combotree" highlight-current >
        </el-tree>
    </div>
</template>

<script>
import { session } from '@/util'
import { mapMutations, mapState } from 'vuex';
import Clickoutside from '@/components/tree_select/utils/clickoutside.js';
export default {
    directives: { Clickoutside },
    components: {},
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: []
        },
        props: {
            type: Object,
            default: {}
        },
        model: {
            type: null,
            default: 　''
        }
    },
    data () {
        return {
        }
    },
    watch: {},
    computed: {
        finalModel: {
            get () {
                return this.model;
            },
            set () {

            }
        },
        middleModel () {
            this.$emit('update:model', this.finalModel)
            return this.finalModel
        },
        ...mapState([
            'showDropdown'
        ])
    },
    methods: {
        toggleDrop () {
            this.toggleDropdown();
        },
        deptTreeNodeHandleClick (data, node, c) {
            this.$emit('node-click', data, node, c);
            this.hideDropdown();
        },
        ...mapMutations([
            'toggleDropdown',
            'hideDropdown'
        ]),
        handleClose () {
            this.hideDropdown();
        }
    },
    created () { },
    mounted () {
    }
}
</script>
<style lang="scss" >
.wcyc-tree-select {
  .combotree {
    position: absolute;
    left: 0;
    top: 36px;
    z-index: 19920104;
    overflow: auto;
    height: 300px;
    min-width: 170px;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/combotree/combotree.vue